<template>
  <div>
    <div class="mt-5">
      <v-row>
        <template>
          <v-col cols="12" sm="12" md="12" class="align-stretch">
            <v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height mitra-card">
              <v-row>
                <v-col class="col-md-2"> 
                  <v-skeleton-loader v-bind="attrs" type="image" height="100" class=" mt-1 rounded-xl elevation-0"></v-skeleton-loader>
                </v-col>
                <v-col class="col-md-2"> 
                  <v-skeleton-loader v-bind="attrs" type="image" height="100" class=" mt-1 rounded-xl elevation-0"></v-skeleton-loader>
                </v-col>
                <v-col class="col-md-2"> 
                  <v-skeleton-loader v-bind="attrs" type="image" height="100" class=" mt-1 rounded-xl elevation-0"></v-skeleton-loader>
                </v-col>
                <v-col class="col-md-2"> 
                  <v-skeleton-loader v-bind="attrs" type="image" height="100" class=" mt-1 rounded-xl elevation-0"></v-skeleton-loader>
                </v-col>
                <v-col class="col-md-2"> 
                  <v-skeleton-loader v-bind="attrs" type="image" height="100" class=" mt-1 rounded-xl elevation-0"></v-skeleton-loader>
                </v-col>
                <v-col class="col-md-2"> 
                  <v-skeleton-loader v-bind="attrs" type="image" height="100" class=" mt-1 rounded-xl elevation-0"></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </div>
    <div class="mt-3">
      <v-row>
        <template>
          <v-col cols="12" sm="4" md="4" class="align-stretch">
            <v-card class="pa-8 elevation-0 rounded-xl hover-shadow fill-height mitra-card">
              <div class="d-flex justify-center">
                <v-skeleton-loader v-bind="attrs" type="image" width="50" height="50" class=" elevation-0"></v-skeleton-loader>
              </div>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
            </v-card>
          </v-col>
        </template>
        <template>
          <v-col cols="12" sm="4" md="4" class="align-stretch">
            <v-card class="pa-8 elevation-0 rounded-xl hover-shadow fill-height mitra-card">
              <div class="d-flex justify-center">
                <v-skeleton-loader v-bind="attrs" type="image" width="50" height="50" class=" elevation-0"></v-skeleton-loader>
              </div>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
            </v-card>
          </v-col>
        </template>
        <template>
          <v-col cols="12" sm="4" md="4" class="align-stretch">
            <v-card class="pa-8 elevation-0 rounded-xl hover-shadow fill-height mitra-card">
              <div class="d-flex justify-center">
                <v-skeleton-loader v-bind="attrs" type="image" width="50" height="50" class=" elevation-0"></v-skeleton-loader>
              </div>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </div>
    <div class="mt-3">
      <v-row>
        <template>
          <v-col cols="12" sm="4" md="7" class="align-stretch">
            <v-card class="pa-8 elevation-0 rounded-xl hover-shadow fill-height mitra-card">
              <v-skeleton-loader v-bind="attrs" type="image" class="fill-height elevation-0"></v-skeleton-loader>
            </v-card>
          </v-col>
        </template>
        <template>
          <v-col cols="12" sm="4" md="5" class="align-stretch">
            <v-card class="pa-8 elevation-0 rounded-xl hover-shadow fill-height mitra-card">
              <v-skeleton-loader v-bind="attrs" type="header" class="elevation-0"></v-skeleton-loader>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
              <v-skeleton-loader v-bind="attrs" type="text" class="mt-2 elevation-0"></v-skeleton-loader>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        attrs: {
          class: '',
          boilerplate: true,
          elevation: 2,
        },
      }
    },
  }
</script>